import * as t from 'io-ts';
import * as F from 'fp-ts/function';
export function identity(type, name) {
    return new t.Type(name !== null && name !== void 0 ? name : type.name, type.is, function (u, c) { return (type.is(u) ? t.success(u) : t.failure(u, c)); }, F.identity);
}
